import router from "./router/index";
import { usePageLoading } from "@/hooks/usePageLoading";

const { loadStart, loadDone } = usePageLoading();
router.beforeEach(async (to, from, next) => {
  loadStart();
  //  判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
  to.matched.length === 0 ? next("/404") : next();
  return;
});

router.afterEach(() => {
  loadDone();
});
